export var ModalName;
(function (ModalName) {
    ModalName[ModalName["Empty"] = 0] = "Empty";
    ModalName[ModalName["InspectData"] = 1] = "InspectData";
    ModalName[ModalName["ShareAnalysis"] = 2] = "ShareAnalysis";
    ModalName[ModalName["Settings"] = 3] = "Settings";
    ModalName[ModalName["BenchmarkList"] = 4] = "BenchmarkList";
    ModalName[ModalName["RenameAnalysis"] = 5] = "RenameAnalysis";
    ModalName[ModalName["RenameSection"] = 6] = "RenameSection";
    ModalName[ModalName["AddWidget"] = 7] = "AddWidget";
    ModalName[ModalName["WidgetWorkshop"] = 8] = "WidgetWorkshop";
    ModalName[ModalName["AddOrEditModel"] = 9] = "AddOrEditModel";
    ModalName[ModalName["AddCustomModel"] = 10] = "AddCustomModel";
    ModalName[ModalName["PortfolioComparisonSelection"] = 11] = "PortfolioComparisonSelection";
    ModalName[ModalName["DownloadPdfModal"] = 12] = "DownloadPdfModal";
    ModalName[ModalName["PortfolioCreation"] = 13] = "PortfolioCreation";
    ModalName[ModalName["PortfolioEdition"] = 14] = "PortfolioEdition";
    ModalName[ModalName["EditJsonWidget"] = 15] = "EditJsonWidget";
    ModalName[ModalName["AddInvestorAccountsOrFunds"] = 16] = "AddInvestorAccountsOrFunds";
    ModalName[ModalName["PublicMarketIndicesList"] = 17] = "PublicMarketIndicesList";
    ModalName[ModalName["ExportData"] = 18] = "ExportData";
    ModalName[ModalName["ImportData"] = 19] = "ImportData";
    ModalName[ModalName["DownloadTemplate"] = 20] = "DownloadTemplate";
    ModalName[ModalName["ImportDataLogs"] = 21] = "ImportDataLogs";
    ModalName[ModalName["BenchmarkCreation"] = 22] = "BenchmarkCreation";
    ModalName[ModalName["AddAllocationBenchmark"] = 23] = "AddAllocationBenchmark";
    ModalName[ModalName["WidgetModal"] = 24] = "WidgetModal";
    ModalName[ModalName["CreateTag"] = 25] = "CreateTag";
    ModalName[ModalName["AssignTags"] = 26] = "AssignTags";
    ModalName[ModalName["DeleteCashflowCustomModel"] = 27] = "DeleteCashflowCustomModel";
    ModalName[ModalName["EditDuplicateWorkspace"] = 28] = "EditDuplicateWorkspace";
    ModalName[ModalName["CreateNewWorkspace"] = 29] = "CreateNewWorkspace";
    ModalName[ModalName["ManageWorkspaces"] = 30] = "ManageWorkspaces";
    ModalName[ModalName["AddPage"] = 31] = "AddPage";
    ModalName[ModalName["PacingPlanCreation"] = 32] = "PacingPlanCreation";
})(ModalName || (ModalName = {}));
export var WorkshopTableStyle;
(function (WorkshopTableStyle) {
    WorkshopTableStyle[WorkshopTableStyle["Simple"] = 0] = "Simple";
})(WorkshopTableStyle || (WorkshopTableStyle = {}));
